module.exports = require('exports?messager!./dist/messager.js')


/*****************
 ** WEBPACK FOOTER
 ** ./~/messager/index.js
 ** module id = 190
 ** module chunks = 1
 **/